document.addEventListener("DOMContentLoaded", function () {
  if (!customElements.get("pq-member-adsorption")) {
    customElements.define(
      "pq-member-adsorption",
      class PqMemberAdsorption extends HTMLElement {
        sticky_start = 0;
        changeStatus = false;
        clickPoint = false;
        lastScrollTop = 0;

        constructor() {
          super();
        }

        connectedCallback() {
          this.init();
          window.addEventListener("scroll", this.scrollHandler.bind(this));
        }

        disconnectedCallback() {
          window.removeEventListener("scroll", this.scrollHandler.bind(this));
        }

        scrollHandler() {
          const adsorption = document.getElementById("adsorption");
          const points = document.querySelectorAll("[data-jump]");
          const sticky =
            adsorption.getBoundingClientRect().top + window.scrollY;

          const scrollTop = window.scrollY;
          this.lastScrollTop = scrollTop;

          if (scrollTop > sticky && !this.changeStatus) {
            this.changeStatus = true;
            this.sticky_start = sticky;
            adsorption.classList.add("adsorption_sticky");
            adsorption.style.top = "0";
          }

          if (this.changeStatus && window.scrollY < this.sticky_start - 10) {
            this.changeStatus = false;
            adsorption.classList.remove("adsorption_sticky");
            adsorption.style.top = "0";
          } else if (this.changeStatus) {
            adsorption.style.top = "0";
          }

          // 如果正在点击跳转，跳过 active 状态的更新
          if (this.clickPoint) return;

          points.forEach((point) => {
            const targetPoint = point.getAttribute("data-jump");
            if (!targetPoint) return;

            const targetElement = document.querySelector(
              `[data-point="${targetPoint}"]`
            );
            if (!targetElement) return;

            const targetOffset =
              targetElement.getBoundingClientRect().top + window.scrollY;
            const targetHeight = targetElement.offsetHeight;

            if (
              window.scrollY >= targetOffset - 50 &&
              window.scrollY < targetOffset + targetHeight
            ) {
              // 获取 item 内部的文本 div
              const itemText = point.querySelector(".point_wrapper_inner_content_item-text");
              if (!itemText) return;
              
              // 如果当前 point 的文本 div 已经是 active，不需要重复操作
              if (itemText.classList.contains("adsorption_active")) {
                return;
              }
              
              // 移除所有 active 状态
              points.forEach((p) => {
                const textDiv = p.querySelector(".point_wrapper_inner_content_item-text");
                if (textDiv) {
                  textDiv.classList.remove("adsorption_active");
                }
              });
              // 添加 active 状态到新的文本 div
              itemText.classList.add("adsorption_active");

              const tabBox = point.closest(".point_wrapper");
              if (tabBox) {
                const tabRect = point.getBoundingClientRect();
                const boxRect = tabBox.getBoundingClientRect();
                const targetScroll =
                  tabBox.scrollLeft +
                  tabRect.left -
                  boxRect.left -
                  (boxRect.width - tabRect.width) / 2;
                tabBox.scrollTo({
                  left: targetScroll,
                  behavior: "smooth",
                });
              }
            }
          });
        }

        init() {
          const adsorption = document.getElementById("adsorption");
          this.sticky_start =
            adsorption.getBoundingClientRect().top + window.scrollY;
          const points = document.querySelectorAll("[data-jump]");

          points.forEach((point) => {
            point.addEventListener("click", (e) => {
              e.preventDefault();
              if (this.clickPoint) return;

              this.clickPoint = true;

              // 先立即定位到当前 tab，确保可见
              const tabBox = point.closest(".point_wrapper");
              if (tabBox) {
                const tabRect = point.getBoundingClientRect();
                const boxRect = tabBox.getBoundingClientRect();
                const targetScroll =
                  tabBox.scrollLeft +
                  tabRect.left -
                  boxRect.left -
                  (boxRect.width - tabRect.width) / 2;
                // 立即滚动到目标位置，不使用平滑动画
                tabBox.scrollTo({
                  left: targetScroll,
                  behavior: "auto",
                });
              }

              // 更新激活状态
              const itemText = point.querySelector(".point_wrapper_inner_content_item-text");
              if (itemText) {
                // 移除所有 active 状态
                points.forEach((p) => {
                  const textDiv = p.querySelector(".point_wrapper_inner_content_item-text");
                  if (textDiv) {
                    textDiv.classList.remove("adsorption_active");
                  }
                });
                // 添加 active 状态到当前文本 div
                itemText.classList.add("adsorption_active");
              }

              const dataPoint = point.dataset.jump;
              if (!dataPoint) {
                this.clickPoint = false;
                return;
              }

              const markerPoint = document.querySelector(
                `[data-point="${dataPoint}"]`
              );
              if (markerPoint) {
                // 计算目标滚动位置
                const targetTop =
                  markerPoint.getBoundingClientRect().top +
                  window.scrollY +
                  30;
                
                window.scrollTo({
                  top: targetTop,
                  behavior: "smooth",
                });

                // 等待滚动完成后再允许 scrollHandler 更新 active 状态
                // 使用更长的延迟确保滚动完成
                setTimeout(() => {
                  this.clickPoint = false;
                  // 滚动完成后，手动调用一次 scrollHandler 来更新 active 状态
                  this.scrollHandler();
                }, 600);
              } else {
                this.clickPoint = false;
              }
            });
          });
        }
      }
    );
  }
});

